import React, { useState } from "react";
import Form from 'react-bootstrap/Form';



import NavBar from "../NavBar/NavBar";
import { FaSearch } from "react-icons/fa";
import arrowDown from "../../images/icons/arrow-down.png";
import filterAdd from "../../images/icons/filter-add.png";
import { AiOutlineSearch } from "react-icons/ai";

import WallBoxTable from "./WallBoxTable";



import "./wallbox.scss";


const Wallbox = () => {
  return (
    <>
        <NavBar />
        <main className="wrapper">
            <div className="page-content">
                <div className="wallbox-area">
                    <div className="pages-title">
                        <div className="h2">Wallboxs</div>
                        <span>Alle produzierten Artikel</span>
                    </div>
                    <div className="search-filter">
                        <form action="">
                            <input type="text" placeholder="Search Product..." />
                            <button type="submit"><AiOutlineSearch/></button>
                        </form>
                        <div className="sort-date">
                            Sort by:
                            <Form.Select aria-label="Default select example">
                                <option>Date Installed</option>
                                <option value="1">Start Installed</option>
                                <option value="2">Timestamp</option>
                                <option value="3">Start Installed</option>
                            </Form.Select> 
                        </div>
                        <div className="filter">
                            Filter <img src={filterAdd} />
                        </div>
                    </div>
                    <div className="wallbox-tabl">
                        <WallBoxTable/>
                    </div>
                </div>
            </div>
        </main>
    </>
  );
};
 

export default Wallbox;
